import { useEffect, useRef, useState } from 'react';

/**
 * Adds a CSS class when the element enters the viewport (once).
 */
export default function useScrollReveal(className = 'fade-in', threshold = 0.15) {
  const ref = useRef(null);
  const [revealed, setRevealed] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || revealed) return undefined;

    if (typeof IntersectionObserver === 'undefined') {
      setRevealed(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setRevealed(true);
          observer.disconnect();
        }
      },
      { threshold }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [revealed, threshold]);

  return { ref, className: revealed ? className : '', revealed };
}
